// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4TXNT","appearModal":"modal_appearModal__na7IT","title":"modal_title__+K4Dm","button":"modal_button__WqsQK"};